// removed by extract-text-webpack-plugin
module.exports = {"defaultInput":"GR06Uuu9","section":"_3Jl6tEVv","content":"_3TxuTudU","description-container":"_39bkMzW0","results-list":"jsVlaV4G","trainer":"_2y-HxZAM"};


//////////////////
// WEBPACK FOOTER
// ./src/client/website/pages/TrainersPage/TrainersPage.styl
// module id = 358
// module chunks = 0